const indianStates = [
  { value: "33", label: "TamilNadu" },
  { value: "29", label: "Karnataka" },
  { value: "32", label: "Kerala" },
  { value: "28", label: "AndhraPradesh" },
  { value: "37", label: "AndhraPradeshNew" },
  { value: "36", label: "Telangana" },
  { value: "12", label: "ArunachalPradesh" },
  { value: "18", label: "Assam" },
  { value: "10", label: "Bihar" },
  { value: "04", label: "Chandigarh" },
  { value: "22", label: "Chhattisgarh" },
  { value: "07", label: "Delhi" },
  { value: "30", label: "Goa" },
  { value: "24", label: "Gujarat" },
  { value: "06", label: "Haryana" },
  { value: "02", label: "HimachalPradesh" },
  { value: "01", label: "JammuAndKashmir" },
  { value: "20", label: "Jharkhand" },
  { value: "31", label: "Lakshadweep" },
  { value: "38", label: "Ladakh" },
  { value: "23", label: "MadhyaPradesh" },
  { value: "27", label: "Maharashtra" },
  { value: "14", label: "Manipur" },
  { value: "17", label: "Meghalaya" },
  { value: "15", label: "Mizoram" },
  { value: "13", label: "Nagaland" },
  { value: "21", label: "Odisha" },
  { value: "34", label: "Puducherry" },
  { value: "03", label: "Punjab" },
  { value: "08", label: "Rajasthan" },
  { value: "11", label: "Sikkim" },
  { value: "16", label: "Tripura" },
  { value: "05", label: "Uttarakhand" },
  { value: "09", label: "UttarPradesh" },
  { value: "19", label: "WestBengal" },
  { value: "35", label: "AndamanAndNicobarIslands" },
  { value: "26", label: "DadraAndNagarHaveliAndDamanAndDiu" },
  { value: "97", label: "OtherTerritory" },
  { value: "99", label: "CentreJurisdiction" },
];

export const getStateOptions = (t: any) =>
  indianStates.map((s) => ({ value: s.value, label: t(s.label) }));

// export const getStateOptions = (t: any) => [
//   { value: "AP", label: t("AndhraPradesh") },
//   { value: "AR", label: t("ArunachalPradesh") },
//   { value: "AS", label: t("Assam") },
//   { value: "BR", label: t("Bihar") },
//   { value: "CT", label: t("Chhattisgarh") },
//   { value: "GA", label: t("Goa") },
//   { value: "GJ", label: t("Gujarat") },
//   { value: "HR", label: t("Haryana") },
//   { value: "HP", label: t("HimachalPradesh") },
//   { value: "JH", label: t("Jharkhand") },
//   { value: "KA", label: t("Karnataka") },
//   { value: "KL", label: t("Kerala") },
//   { value: "MP", label: t("MadhyaPradesh") },
//   { value: "MH", label: t("Maharashtra") },
//   { value: "MN", label: t("Manipur") },
//   { value: "ML", label: t("Meghalaya") },
//   { value: "MZ", label: t("Mizoram") },
//   { value: "NL", label: t("Nagaland") },
//   { value: "OD", label: t("Odisha") },
//   { value: "PB", label: t("Punjab") },
//   { value: "RJ", label: t("Rajasthan") },
//   { value: "SK", label: t("Sikkim") },
//   { value: "TN", label: t("TamilNadu") },
//   { value: "TG", label: t("Telangana") },
//   { value: "TR", label: t("Tripura") },
//   { value: "UP", label: t("UttarPradesh") },
//   { value: "UT", label: t("Uttarakhand") },
//   { value: "WB", label: t("WestBengal") },
// ];

const countries = [
  { value: "IN", label: "India" },
  { value: "US", label: "UnitedStates" },
  { value: "GB", label: "UnitedKingdom" },
  { value: "AU", label: "Australia" },
  { value: "CA", label: "Canada" },
  { value: "CN", label: "China" },
  { value: "RU", label: "RussianFederation" },
  { value: "FR", label: "France" },
  { value: "IT", label: "Italy" },
  { value: "JP", label: "Japan" },
  { value: "ID", label: "Indonesia" },
  { value: "MX", label: "Mexico" },
  { value: "MY", label: "Malaysia" },
  { value: "NP", label: "Nepal" },
  { value: "NZ", label: "NewZealand" },
  { value: "SG", label: "Singapore" },
  { value: "AE", label: "UnitedArabEmirates" },
  { value: "ES", label: "Spain" },
  { value: "LK", label: "SriLanka" },
  { value: "AF", label: "Afghanistan" },
  { value: "AL", label: "Albania" },
  { value: "DZ", label: "Algeria" },
  { value: "AS", label: "AmericanSamoa" },
  { value: "AD", label: "Andorra" },
  { value: "AO", label: "Angola" },
  { value: "AI", label: "Anguilla" },
  { value: "AQ", label: "Antarctica" },
  { value: "AG", label: "AntiguaAndBarbuda" },
  { value: "AR", label: "Argentina" },
  { value: "AM", label: "Armenia" },
  { value: "AW", label: "Aruba" },
  { value: "AT", label: "Austria" },
  { value: "AZ", label: "Azerbaijan" },
  { value: "BS", label: "Bahamas" },
  { value: "BH", label: "Bahrain" },
  { value: "BD", label: "Bangladesh" },
  { value: "BB", label: "Barbados" },
  { value: "BY", label: "Belarus" },
  { value: "BE", label: "Belgium" },
  { value: "BZ", label: "Belize" },
  { value: "BJ", label: "Benin" },
  { value: "BM", label: "Bermuda" },
  { value: "BT", label: "Bhutan" },
  { value: "BO", label: "Bolivia" },
  { value: "BQ", label: "BonaireSintEustatiusAndSaba" },
  { value: "BA", label: "BosniaAndHerzegovina" },
  { value: "BW", label: "Botswana" },
  { value: "BV", label: "BouvetIsland" },
  { value: "BR", label: "Brazil" },
  { value: "IO", label: "BritishIndianOceanTerritory" },
  { value: "BN", label: "BruneiDarussalam" },
  { value: "BG", label: "Bulgaria" },
  { value: "BF", label: "BurkinaFaso" },
  { value: "BI", label: "Burundi" },
  { value: "CV", label: "CaboVerde" },
  { value: "KH", label: "Cambodia" },
  { value: "CM", label: "Cameroon" },
  { value: "KY", label: "CaymanIslands" },
  { value: "CF", label: "CentralAfricanRepublic" },
  { value: "TD", label: "Chad" },
  { value: "CL", label: "Chile" },
  { value: "CX", label: "ChristmasIsland" },
  { value: "CC", label: "CocosKeelingIslands" },
  { value: "CO", label: "Colombia" },
  { value: "KM", label: "Comoros" },
  { value: "CG", label: "Congo" },
  { value: "CD", label: "CongoDemocraticRepublic" },
  { value: "CK", label: "CookIslands" },
  { value: "CR", label: "CostaRica" },
  { value: "CI", label: "CoteDIvoire" },
  { value: "HR", label: "Croatia" },
  { value: "CU", label: "Cuba" },
  { value: "CW", label: "Curacao" },
  { value: "CY", label: "Cyprus" },
  { value: "CZ", label: "CzechRepublic" },
  { value: "DK", label: "Denmark" },
  { value: "DJ", label: "Djibouti" },
  { value: "DM", label: "Dominica" },
  { value: "DO", label: "DominicanRepublic" },
  { value: "EC", label: "Ecuador" },
  { value: "EG", label: "Egypt" },
  { value: "SV", label: "ElSalvador" },
  { value: "GQ", label: "EquatorialGuinea" },
  { value: "ER", label: "Eritrea" },
  { value: "EE", label: "Estonia" },
  { value: "SZ", label: "Eswatini" },
  { value: "ET", label: "Ethiopia" },
  { value: "FK", label: "FalklandIslands" },
  { value: "FO", label: "FaroeIslands" },
  { value: "FJ", label: "Fiji" },
  { value: "FI", label: "Finland" },
  { value: "GF", label: "FrenchGuiana" },
  { value: "PF", label: "FrenchPolynesia" },
  { value: "TF", label: "FrenchSouthernTerritories" },
  { value: "GA", label: "Gabon" },
  { value: "GM", label: "Gambia" },
  { value: "GE", label: "Georgia" },
  { value: "DE", label: "Germany" },
  { value: "GH", label: "Ghana" },
  { value: "GI", label: "Gibraltar" },
  { value: "GR", label: "Greece" },
  { value: "GL", label: "Greenland" },
  { value: "GD", label: "Grenada" },
  { value: "GP", label: "Guadeloupe" },
  { value: "GU", label: "Guam" },
  { value: "GT", label: "Guatemala" },
  { value: "GG", label: "Guernsey" },
  { value: "GN", label: "Guinea" },
  { value: "GW", label: "GuineaBissau" },
  { value: "GY", label: "Guyana" },
  { value: "HT", label: "Haiti" },
  { value: "HM", label: "HeardAndMcDonaldIslands" },
  { value: "VA", label: "HolySee" },
  { value: "HN", label: "Honduras" },
  { value: "HK", label: "HongKong" },
  { value: "HU", label: "Hungary" },
  { value: "IS", label: "Iceland" },
  { value: "IR", label: "Iran" },
  { value: "IQ", label: "Iraq" },
  { value: "IE", label: "Ireland" },
  { value: "IM", label: "IsleOfMan" },
  { value: "IL", label: "Israel" },
  { value: "JM", label: "Jamaica" },
  { value: "JE", label: "Jersey" },
  { value: "JO", label: "Jordan" },
  { value: "KZ", label: "Kazakhstan" },
  { value: "KE", label: "Kenya" },
  { value: "KI", label: "Kiribati" },
  { value: "KP", label: "KoreaNorth" },
  { value: "KR", label: "KoreaSouth" },
  { value: "KW", label: "Kuwait" },
  { value: "KG", label: "Kyrgyzstan" },
  { value: "LA", label: "LaoPeoplesDemocraticRepublic" },
  { value: "LV", label: "Latvia" },
  { value: "LB", label: "Lebanon" },
  { value: "LS", label: "Lesotho" },
  { value: "LR", label: "Liberia" },
  { value: "LY", label: "Libya" },
  { value: "LI", label: "Liechtenstein" },
  { value: "LT", label: "Lithuania" },
  { value: "LU", label: "Luxembourg" },
  { value: "MO", label: "Macao" },
  { value: "MG", label: "Madagascar" },
  { value: "MW", label: "Malawi" },
  { value: "MV", label: "Maldives" },
  { value: "ML", label: "Mali" },
  { value: "MT", label: "Malta" },
  { value: "MH", label: "MarshallIslands" },
  { value: "MQ", label: "Martinique" },
  { value: "MR", label: "Mauritania" },
  { value: "MU", label: "Mauritius" },
  { value: "YT", label: "Mayotte" },
  { value: "FM", label: "Micronesia" },
  { value: "MD", label: "Moldova" },
  { value: "MC", label: "Monaco" },
  { value: "MN", label: "Mongolia" },
  { value: "ME", label: "Montenegro" },
  { value: "MS", label: "Montserrat" },
  { value: "MA", label: "Morocco" },
  { value: "MZ", label: "Mozambique" },
  { value: "MM", label: "Myanmar" },
  { value: "NA", label: "Namibia" },
  { value: "NR", label: "Nauru" },
  { value: "NL", label: "Netherlands" },
  { value: "NC", label: "NewCaledonia" },
  { value: "NI", label: "Nicaragua" },
  { value: "NE", label: "Niger" },
  { value: "NG", label: "Nigeria" },
  { value: "NU", label: "Niue" },
  { value: "NF", label: "NorfolkIsland" },
  { value: "MK", label: "NorthMacedonia" },
  { value: "MP", label: "NorthernMarianaIslands" },
  { value: "NO", label: "Norway" },
  { value: "OM", label: "Oman" },
  { value: "PK", label: "Pakistan" },
  { value: "PW", label: "Palau" },
  { value: "PS", label: "PalestineState" },
  { value: "PA", label: "Panama" },
  { value: "PG", label: "PapuaNewGuinea" },
  { value: "PY", label: "Paraguay" },
  { value: "PE", label: "Peru" },
  { value: "PH", label: "Philippines" },
  { value: "PN", label: "Pitcairn" },
  { value: "PL", label: "Poland" },
  { value: "PT", label: "Portugal" },
  { value: "PR", label: "PuertoRico" },
  { value: "QA", label: "Qatar" },
  { value: "RE", label: "Reunion" },
  { value: "RO", label: "Romania" },
  { value: "RW", label: "Rwanda" },
  { value: "BL", label: "SaintBarthelemy" },
  { value: "SH", label: "SaintHelena" },
  { value: "KN", label: "SaintKittsAndNevis" },
  { value: "LC", label: "SaintLucia" },
  { value: "MF", label: "SaintMartin" },
  { value: "PM", label: "SaintPierreAndMiquelon" },
  { value: "VC", label: "SaintVincentAndTheGrenadines" },
  { value: "WS", label: "Samoa" },
  { value: "SM", label: "SanMarino" },
  { value: "ST", label: "SaoTomeAndPrincipe" },
  { value: "SA", label: "SaudiArabia" },
  { value: "SN", label: "Senegal" },
  { value: "RS", label: "Serbia" },
  { value: "SC", label: "Seychelles" },
  { value: "SL", label: "SierraLeone" },
  { value: "SX", label: "SintMaarten" },
  { value: "SK", label: "Slovakia" },
  { value: "SI", label: "Slovenia" },
  { value: "SB", label: "SolomonIslands" },
  { value: "SO", label: "Somalia" },
  { value: "ZA", label: "SouthAfrica" },
  { value: "GS", label: "SouthGeorgiaAndSandwichIslands" },
  { value: "SS", label: "SouthSudan" },
  { value: "SD", label: "Sudan" },
  { value: "SR", label: "Suriname" },
  { value: "SJ", label: "SvalbardAndJanMayen" },
  { value: "SE", label: "Sweden" },
  { value: "CH", label: "Switzerland" },
  { value: "SY", label: "SyrianArabRepublic" },
  { value: "TW", label: "Taiwan" },
  { value: "TJ", label: "Tajikistan" },
  { value: "TZ", label: "Tanzania" },
  { value: "TH", label: "Thailand" },
  { value: "TL", label: "TimorLeste" },
  { value: "TG", label: "Togo" },
  { value: "TK", label: "Tokelau" },
  { value: "TO", label: "Tonga" },
  { value: "TT", label: "TrinidadAndTobago" },
  { value: "TN", label: "Tunisia" },
  { value: "TR", label: "Turkey" },
  { value: "TM", label: "Turkmenistan" },
  { value: "TC", label: "TurksAndCaicosIslands" },
  { value: "TV", label: "Tuvalu" },
  { value: "UG", label: "Uganda" },
  { value: "UA", label: "Ukraine" },
  { value: "UM", label: "UnitedStatesOutlyingIslands" },
  { value: "UY", label: "Uruguay" },
  { value: "UZ", label: "Uzbekistan" },
  { value: "VU", label: "Vanuatu" },
  { value: "VE", label: "Venezuela" },
  { value: "VN", label: "VietNam" },
  { value: "VG", label: "VirginIslandsBritish" },
  { value: "VI", label: "VirginIslandsUS" },
  { value: "WF", label: "WallisAndFutuna" },
  { value: "EH", label: "WesternSahara" },
  { value: "YE", label: "Yemen" },
  { value: "ZM", label: "Zambia" },
  { value: "ZW", label: "Zimbabwe" },
];

export const getCountryOptions = (t: any) =>
  countries.map((c) => ({ value: c.value, label: t(c.label) }));

export function toAddress(input?: string) {
  if (input) {
    try {
      return JSON.parse(input);
    } catch (ex) {
      return {
        address1: "",
        address2: "",
        city: "",
        state: "",
        country: "",
        pincode: "",
      };
    }
  } else {
    return {
      address1: "",
      address2: "",
      city: "",
      state: "",
      country: "",
      pincode: "",
    };
  }
}

export const toPlainAddress = (t: any, input?: string) => {
  try {
    if (input) {
      const obj = toAddress(input);
      let result = "";
      if (obj.address1) {
        result = obj.address1;
      }
      if (obj.address2) {
        result += `${result.length > 0 ? ", " : ""}${obj.address2}`;
      }
      if (obj.city) {
        result += `${result.length > 0 ? ", " : ""}${obj.city}`;
      }
      if (obj.state) {
        const state = indianStates.find((s) => s.value === obj.state);
        if (state?.label) {
          result += `${result.length > 0 ? ", " : ""}${t(state.label)}`;
        }
      }
      if (obj.country) {
        const country = countries.find((s) => s.value === obj.country);
        if (country?.label) {
          result += `${result.length > 0 ? ", " : ""}${t(country.label)}`;
        }
      }
      if (obj.pincode) {
        result += `${result.length > 0 ? ", " : ""}${obj.pincode}`;
      }
      return result;
    } else {
      return "";
    }
  } catch (ex) {
    return "";
  }
};

export const validateAddress = (value: any) => {
  try {
    const address = JSON.parse(value);
    return !!(
      address?.address1?.trim() &&
      address?.city?.trim() &&
      address?.state?.trim() &&
      address?.country?.trim() &&
      address?.pincode?.length >= 5
    );
  } catch (ex) {
    return false;
  }
};
